import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `Sehemu ya nyumbani ya gumzo la siri la ${ctx.brand}`,
    languageButtonLabel: `Lugha`,
    languageModalTitle: `Chagua lugha`,
    languageModalCloseLabel: `Funga menyu ya lugha`,
  },
  languageOptions: {
    'en-US': {
      label: `Kiingereza (Marekani)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `Kiingereza (Kenya)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `Kiingereza (Nigeria)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `Kiingereza (Singapuri)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `Kireno (Ureno)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Kireno (Brazil)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `Kijerumani (Ujerumani)`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Kijerumani (Austria)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Kijerumani (Uswisi)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `Kihispania (Uhispania)`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `Kifaransa (Ufaransa)`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `Kiitaliano (Italia)`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `Kiholanzi (Uholanzi)`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Kipolandi (Polandi)`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `Kiswidi (Uswidi)`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Kidenmaki (Denmaki)`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Kifini (Ufini)`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Kinorwe (Norwe)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Kiaisilandi (Aisilandi)`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `Kijapani (Japani)`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `Kikorea (Korea Kusini)`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `Kichina (Uchina)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `Kikantoni (Hong Kong SAR China)`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Kivietinamu (Vietnamu)`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `Kithai (Thailandi)`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Kiindonesia (Indonesia)`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Kiswahili (Kenya)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `Kihindi (India)`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `Kibangla (Bangladeshi)`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `Kimarathi (India)`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `Kitelugu (India)`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `Kiajemi (Iran)`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `Kiurdu (Pakistani)`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `Kipunjabi (Pakistani)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Kipijini cha Naijeria (Nigeria)`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `Kirusi (Urusi)`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `Kiarabu (Saudia)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `Kiarabu (Falme za Kiarabu)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `Kiarabu (Katari)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `Kidarija cha Moroko`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Kituruki (Uturuki)`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `Chagua lugha`,
    closeLabel: `Funga menyu ya lugha`,
  },
  languageHint: (ctx) => `Ruka katika matoleo ${ctx.localesCount}+ bila kuunda akaunti.`,
  readPagePrompt: ({languageLabel}) => `Soma ukurasa huu kwa ${languageLabel}.`,
};
